import ClickWrapper from '@/components/ClickWrapper'
import { LinkInfo } from '@/utils/fetchers/attachment'
import useUniversalNavigate from '@/utils/hooks/useUniversalNavigate'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import styles from './LinkCard.module.css'

export interface LinkCardProps extends HTMLAttributes<HTMLDivElement> {
	data: LinkInfo | undefined
}

export default function LinkCard({ data, className, ...props }: LinkCardProps) {
	const navigate = useUniversalNavigate()
	if (!data) {
		return null
	}
	const { audio, pictureUrl, title, brandLogoImage, linkUrl } = data
	return (
		<ClickWrapper
			data-anonymous-gated-interaction
			whileTap={{
				scale: 0.98,
			}}
			onClick={(e) => {
				e.stopPropagation()
				navigate(linkUrl, e)
			}}
		>
			<div {...props} className={clsx(styles.root, className)}>
				<div>
					<img
						loading="lazy"
						referrerPolicy="no-referrer"
						src={pictureUrl}
						className={styles.image}
					/>
				</div>
				<div>
					<header className={styles.header}>{title}</header>
					<footer className={styles.footer}>
						<div>
							{/* author */}
							{audio?.author}
						</div>
						<div>{/* brand? */}</div>
					</footer>
				</div>
			</div>
		</ClickWrapper>
	)
}
